export enum AosUserType {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
    MANUAL = 'MANUAL',
}
